import GameActionType from 'actions/game/gameActionType';

const initialState = {
  loading: false,
  freeGameProviders: [],
  freeGamesV2Providers: [],
  freeGames: [],
  freeGamesV2: [],
  freeGameAmountRestrictions: {},
  freeGamesV2AmountRestrictions: [],
  freeGameLoading: false,
  freeGameAmountLoading: false,
};

const gameReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case GameActionType.CHANGE_GAME_LOADING_STATE:
    return {
      ...state,
      loading: payload.state,
    };

  case GameActionType.SAVE_FREE_GAME_PROVIDERS:
    return {
      ...state,
      freeGameProviders: payload.data,
    };
  case GameActionType.RESET_FREE_GAME_PROVIDERS:
    return {
      ...state,
      freeGameProviders: [],
    };
  case GameActionType.SAVE_FREE_GAMES_V2_PROVIDERS:
    return {
      ...state,
      freeGamesV2Providers: payload.data,
    };
  case GameActionType.RESET_FREE_GAMES_V2_PROVIDERS:
    return {
      ...state,
      freeGamesV2Providers: [],
    };
  case GameActionType.SAVE_FREE_GAMES:
    return {
      ...state,
      freeGames: payload.data,
    };
  case GameActionType.RESET_FREE_GAMES:
    return {
      ...state,
      freeGames: [],
    };
  case GameActionType.SAVE_FREE_GAMES_V2:
    return {
      ...state,
      freeGamesV2: payload.data,
    };
  case GameActionType.RESET_FREE_GAMES_V2:
    return {
      ...state,
      freeGamesV2: [],
    };
  case GameActionType.SAVE_FREE_GAME_AMOUNT_RESTRICTIONS:
    return {
      ...state,
      freeGameAmountRestrictions: payload.data,
    };
  case GameActionType.RESET_FREE_GAME_AMOUNT_RESTRICTIONS:
    return {
      ...state,
      freeGameAmountRestrictions: {},
    };
  case GameActionType.SAVE_FREE_GAMES_V2_AMOUNT_RESTRICTIONS:
    return {
      ...state,
      freeGamesV2AmountRestrictions: payload.data,
    };
  case GameActionType.RESET_FREE_GAMES_V2_AMOUNT_RESTRICTIONS:
    return {
      ...state,
      freeGamesV2AmountRestrictions: [],
    };
  case GameActionType.CHANGE_FREE_GAME_LOADING_STATE:
    return {
      ...state,
      freeGameLoading: payload.state,
    };
  case GameActionType.CHANGE_FREE_GAME_AMOUNT_LOADING_STATE:
    return {
      ...state,
      freeGameAmountLoading: payload.state,
    };
  default:
    return state;
  }
};

export default gameReducer;
